import React from 'react';

export function Card({ title, icon, children, span, minH, accent }) {
  return (
    <div style={{
      background: 'var(--surface)',
      border: `1px solid ${accent ? accent + '40' : 'var(--border)'}`,
      borderRadius: 14,
      overflow: 'hidden',
      gridColumn: span ? `span ${span}` : undefined,
      minHeight: minH,
      display: 'flex',
      flexDirection: 'column',
      boxShadow: accent
        ? `0 0 0 1px ${accent}20, 0 2px 12px rgba(31,88,164,0.10)`
        : '0 1px 6px rgba(31,88,164,0.07)',
    }}>
      {title && (
        <div style={{
          padding: '13px 18px 11px',
          borderBottom: '1px solid var(--border)',
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          background: 'var(--bg)',
        }}>
          {icon && <span style={{ fontSize: 15 }}>{icon}</span>}
          <span style={{
            fontSize: 11, fontWeight: 700, letterSpacing: 1.2,
            textTransform: 'uppercase', color: 'var(--text-muted)',
          }}>
            {title}
          </span>
        </div>
      )}
      <div style={{ padding: '16px 18px', flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </div>
    </div>
  );
}

export function StatItem({ label, value, sub, color }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <span style={{ fontSize: 10, color: 'var(--text-muted)', fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase' }}>{label}</span>
      <span style={{ fontSize: 18, fontWeight: 700, color: color || 'var(--text)', lineHeight: 1.2 }}>{value || '—'}</span>
      {sub && <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{sub}</span>}
    </div>
  );
}

export function Badge({ label, color, bg, size }) {
  return (
    <span style={{
      fontSize: size === 'sm' ? 10 : 11,
      fontWeight: 700,
      letterSpacing: 0.6,
      color: color || 'var(--text-dim)',
      background: bg || (color ? color + '18' : 'var(--surface2)'),
      border: `1px solid ${color ? color + '35' : 'var(--border)'}`,
      borderRadius: 6,
      padding: size === 'sm' ? '2px 7px' : '3px 10px',
      display: 'inline-flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
    }}>
      {label}
    </span>
  );
}

export function RiskDot({ rating }) {
  if (!rating) return null;
  const isGreen = rating.includes('🟢') || rating.toLowerCase().includes('low');
  const isRed   = rating.includes('🔴') || rating.toLowerCase().includes('high');
  const color   = isGreen ? '#10b981' : isRed ? '#ef4444' : '#f59e0b';
  const label   = isGreen ? 'Low' : isRed ? 'High' : 'Medium';
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5 }}>
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: color, display: 'inline-block', flexShrink: 0 }} />
      <span style={{ fontSize: 12, color, fontWeight: 600 }}>{label}</span>
    </span>
  );
}

export function Stars({ n, max = 5, size = 16 }) {
  return (
    <span style={{ display: 'inline-flex', gap: 2 }}>
      {Array.from({ length: max }, (_, i) => (
        <span key={i} style={{ fontSize: size, color: i < n ? '#f59e0b' : 'var(--border)', lineHeight: 1 }}>★</span>
      ))}
    </span>
  );
}

export function SectionDivider({ label }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '6px 0 10px' }}>
      <span style={{ fontSize: 10, fontWeight: 700, color: 'var(--text-muted)', letterSpacing: 1, textTransform: 'uppercase', whiteSpace: 'nowrap' }}>
        {label}
      </span>
      <div style={{ flex: 1, height: 1, background: 'var(--border)' }} />
    </div>
  );
}

export function InfoRow({ label, value, mono }) {
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start', marginBottom: 7 }}>
      <span style={{ fontSize: 11, color: 'var(--text-muted)', fontWeight: 600, minWidth: 90, flexShrink: 0 }}>{label}</span>
      <span style={{ fontSize: 12, color: 'var(--text-dim)', fontFamily: mono ? 'monospace' : undefined, lineHeight: 1.5 }}>
        {value || '—'}
      </span>
    </div>
  );
}

export function ProgressBar({ pct, color }) {
  const n = parseFloat(pct) || 0;
  return (
    <div style={{ background: 'var(--border)', borderRadius: 4, height: 6, overflow: 'hidden', width: '100%' }}>
      <div style={{ width: `${Math.min(n, 100)}%`, height: '100%', background: color || 'var(--accent)', borderRadius: 4, transition: 'width 0.6s ease' }} />
    </div>
  );
}
